import React, { useState, useRef, useEffect } from 'react';
import { 
  exportLocationsToJson,
  exportLocationsToCsv,
  exportLocationsToGeoJson
} from '../../Services';

/**
 * Multi-format Export Dropdown Component
 * Provides options to export location data in JSON, CSV, and GeoJSON formats
 */
const ExportDropdown = ({ locations }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Export handlers
  const handleExportJson = () => {
    exportLocationsToJson(locations, 'locations.json');
    setIsOpen(false);
  };

  const handleExportCsv = () => {
    exportLocationsToCsv(locations, 'locations.csv');
    setIsOpen(false);
  };

  const handleExportGeoJson = () => {
    exportLocationsToGeoJson(locations, 'locations.geojson');
    setIsOpen(false);
  };

  // Don't render if no locations
  if (locations.length === 0) return null;

  return (
    <div className="export-dropdown" ref={dropdownRef}>
      <button
        className="export-dropdown-btn"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        aria-haspopup="true"
      >
        Export Locations
        <span className={`dropdown-arrow ${isOpen ? 'open' : ''}`}>▼</span>
      </button>
      
      {isOpen && (
        <div className="export-dropdown-menu">
          <button
            className="export-option"
            onClick={handleExportCsv}
            title="Suitable for Excel editing and data analysis"
          >
            <div className="export-option-content">
              <span className="format-name">Export as CSV</span>
              <span className="format-desc">Excel editing</span>
            </div>
          </button>
          
          <button
            className="export-option"
            onClick={handleExportJson}
            title="VRP system standard format, can be re-imported"
          >
            <div className="export-option-content">
              <span className="format-name">Export as JSON</span>
              <span className="format-desc">System backup</span>
            </div>
          </button>
          
          <button
            className="export-option"
            onClick={handleExportGeoJson}
            title="Geographic information system standard format"
          >
            <div className="export-option-content">
              <span className="format-name">Export as GeoJSON</span>
              <span className="format-desc">GIS analysis</span>
            </div>
          </button>
        </div>
      )}
    </div>
  );
};

export default ExportDropdown;
